import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button} from 'antd';
import {useTranslation} from 'react-i18next';
import {
  StyledTransactionDetailsPanel,
  StyledTransactionDetailsPanelContainer,
  StyledTransactionDetailsPanelContent,
  StyledTransactionDetailsPanelBody,
  StyledTransactionDetailsPanelHeader,
  StyledTransactionDetailsPanelHeaderText,
  StyledTransactionDetailsPanelFooter,
} from './StyledTransactionDetailsPanel';
import {ChevronRightIcon} from '../../../../icons';


const TransactionDetailsPanel = ({
  backButtonText = '',
  children,
  contentClassName,
  fixed = false,
  footer,
  headerRightContent,
  hiddenOverflow = false,
  onBack,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const panelRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (panelRef.current) {
      let domElement = panelRef.current;
      let offset = 0;
      let parentContainer = document.getElementById('app-content-container');
      if (parentContainer && !fixed) offset -= parentContainer.scrollTop;
      while (domElement) {
        offset += domElement.offsetTop;
        domElement = domElement.offsetParent;
      }
      setOffset(offset);
    }
  }, [panelRef, fixed]);

  return (
    <StyledTransactionDetailsPanel {...rest}>
      <StyledTransactionDetailsPanelContainer
        ref={panelRef}
        hiddenOverflow={hiddenOverflow}
        fixed={fixed}
      >
        <StyledTransactionDetailsPanelContent className={contentClassName}>
          <StyledTransactionDetailsPanelHeader>
            <Button
              icon={<ChevronRightIcon />}
              onClick={(e) => onBack && onBack(e)}
              size='small'
              type='text'
            >
              {backButtonText}
            </Button>

            {!backButtonText && (
              <StyledTransactionDetailsPanelHeaderText>
                {t('transaction')} {t('details')}
              </StyledTransactionDetailsPanelHeaderText>
            )}
            {headerRightContent}
          </StyledTransactionDetailsPanelHeader>
          <StyledTransactionDetailsPanelBody fixed={fixed} offset={offset}>
            {children}
          </StyledTransactionDetailsPanelBody>
          {footer && (
            <StyledTransactionDetailsPanelFooter>
              {footer}
            </StyledTransactionDetailsPanelFooter>
          )}
        </StyledTransactionDetailsPanelContent>
      </StyledTransactionDetailsPanelContainer>
    </StyledTransactionDetailsPanel>
  );
}

TransactionDetailsPanel.propTypes = {
  backButtonText: PropTypes.string,
  contentClassName: PropTypes.string,
  hiddenOverflow: PropTypes.bool,
  fixed: PropTypes.bool,
  footer: PropTypes.node,
  onBack: PropTypes.func
}

export default TransactionDetailsPanel;
